import React from 'react';

interface ArrowRightSvgProps {
  stroke?: string;
}

export const ArrowRightSvg: React.FunctionComponent<ArrowRightSvgProps> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 4L10 8L6 12"
      stroke={props.stroke || '#0D99D6'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
